





















































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { eventBus } from '@/main';
import { DATA } from '@/config/data';
import Paging from '@/shared/components/Paging.vue';
import { APP_CONFIG } from '@/config/app-config';
import { RechargeHistory } from '@/models/recharge-history';

import creditServices from '@/services/credit-services';

@Component({
    components: {
        Paging,
        Loading
    }
})
export default class RechargeHistories extends Vue {
    private pageSettings = {
      rowPerPage: 10,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listRechargeHistories: RechargeHistory[] = [];
    private isLoading = false;

    private async created() {
        eventBus.$on(APP_CONFIG.eventBusAction.reloadWithdrawalHistories, () => {
            this.pageSettings.pageIndex = 1;
            this.loadHistories();
        });
        
        this.loadHistories();
    }

    private async loadHistories() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        this.listRechargeHistories = [];
        const result = await creditServices.rechargeHistories(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, '');
        if (result && result.status === 200 && result.data.status === 200) {
            this.pageSettings.total = result.data.total;
            for (const item of result.data.data) {
                const history = new RechargeHistory();
                history.amount = item.Amount;
                history.createdBy = item.CreatedBy;
                history.createDate = item.CreatedDate;
                history.id = item.ID;
                history.method = item.Method;
                history.rechargeId = item.RechargeID;
                history.status = item.Status;
                history.statusDetail = DATA.statusRecharge.find(x => x.value === item.Status) || {};
                history.tradeContent = item.TradeContent;
                history.userRecharge = item.UserRecharge;
                history.userName = item.Username;
                this.listRechargeHistories.push(history);
            }
        }

        this.isLoading = false;
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadHistories();
    }
}
